import { Component } from "react"

/* Modal */
import Modal from "react-modal"

/* Components */
import { Icon, Input } from "../../components"

/* Icons */
import { LoadingOutlined } from "@ant-design/icons"

/* REST API */
import { save } from "../../api/Admin"

/* Widgets */
import { toast } from "../common"

Modal.setAppElement("#root")


/* The letters of a generated password — without the ones which look alike (0 and O, 1 and l) */
const LETTERS = "abcdefghijkmnpqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ23456789"


/* Widget Admin Form — a new administrator or a change of one. Opened by the reference:
   this._form.current.open() for a new one, this._form.current.open(admin) for a change.
   Props: onSaved */
class AdminForm extends Component {

    constructor() {
        super()

        this.state = {
            visible: false,
            id: null,
            name: "",
            email: "",
            password: "",
            saving: false
        }
    }

    open = (admin = null) => {
        this.setState({
            visible: true,
            id: admin ? admin.id : null,
            name: admin && admin.name ? admin.name : "",
            email: admin && admin.email ? admin.email : "",
            password: "",
            saving: false
        })
    }

    close = () => {

        if (this.state.saving) {
            return
        }

        this.setState({ visible: false })
    }

    /* A strong password at once — it is copied to send it to the new administrator */
    generate = () => {

        let password = ""

        const values = new Uint32Array(12)
        window.crypto.getRandomValues(values)

        values.forEach(value => {
            password += LETTERS[value % LETTERS.length]
        })

        this.setState({ password })

        if (navigator.clipboard) {
            navigator.clipboard.writeText(password).then(() => toast.success("Пароль скопирован")).catch(() => { })
        }
    }

    save = () => {

        /* Fields */
        const { id, name, email, password, saving } = this.state
        const { onSaved } = this.props

        if (saving) {
            return
        }

        let valid = true

        if (name.trim().length === 0) {
            this._name.error("Введите имя")
            valid = false
        }

        if (!/^\S+@\S+\.\S+$/.test(email.trim())) {
            this._email.error("Введите почту")
            valid = false
        }

        if ((!id && password.length < 8) || (id && password.length > 0 && password.length < 8)) {
            this._password.error("Не короче 8 символов")
            valid = false
        }

        if (!valid) {
            return
        }

        this.setState({ saving: true })

        save({ id, name: name.trim(), email: email.trim(), password }).then(response => {

            this.setState({ saving: false })

            if (response && response.status === 200) {
                toast.success(id ? "Сохранено" : "Администратор добавлен")
                this.setState({ visible: false })
                onSaved()
                return
            }

            if (response && response.data && response.data.code === "EMAIL_TAKEN") {
                this._email.error("Эта почта уже занята")
                return
            }

            toast.error("Что-то пошло не так! Попробуйте позднее")
        }).catch(() => {
            this.setState({ saving: false })
            toast.error("Что-то пошло не так! Попробуйте позднее")
        })
    }

    render = () => {

        /* Fields */
        const { visible, id, name, email, password, saving } = this.state

        return (
            <Modal
                isOpen={visible}
                onRequestClose={this.close}
                className="wide-modal admin-form"
                overlayClassName="wide-modal-overlay"
                closeTimeoutMS={200}
            >

                <div className="wide-modal-header">
                    <h2>{id ? "Изменить администратора" : "Новый администратор"}</h2>
                    <div onClick={this.close} className="wide-modal-close">
                        <Icon name="close" size={11} width={2.2} />
                    </div>
                </div>

                {visible &&
                    <div className="wide-modal-body">

                        <div className="wide-modal-label">Кто это</div>
                        <Input ref={ref => this._name = ref} label="Имя" maxLength={100} value={name} onChange={event => this.setState({ name: event.target.value })} />
                        <Input ref={ref => this._email = ref} label="Почта — логин в админку" maxLength={150} value={email} onChange={event => this.setState({ email: event.target.value })} />

                        <div className="wide-modal-label">Пароль</div>
                        <div className="wide-modal-hint">
                            {id ? "Пусто — пароль останется прежним. Новый пароль не выкидывает из админки тех, кто уже вошёл." : "Не короче 8 символов. Сгенерированный пароль сразу копируется — отправьте его новому администратору."}
                        </div>
                        <Input ref={ref => this._password = ref} secure label={id ? "Новый пароль" : "Пароль"} maxLength={100} value={password} onChange={event => this.setState({ password: event.target.value })} />

                        <div onClick={this.generate} className="admin-generate">
                            <Icon name="sparkle" size={15} width={2} />
                            Сгенерировать пароль
                        </div>

                        <div className="admin-form-note">
                            <Icon name="shield" size={16} width={2} />
                            <span>Пока у каждого администратора полный доступ ко всем разделам. Роли и права появятся отдельно.</span>
                        </div>

                        <div onClick={this.save} className={`organization-details-button sticky ${saving ? "disabled" : ""}`}>
                            {saving ? <LoadingOutlined /> : (id ? "Сохранить" : "Добавить администратора")}
                        </div>

                    </div>
                }

            </Modal>
        )
    }
}

export default AdminForm
